import { createAsyncThunk } from "@reduxjs/toolkit";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { CreateListingFormData } from "../../pages/CreateListing/EditListing";
import { uploadToCloudinary } from "../../utils/helperFunctions/uploadToCloudinary";
import { getLatLng } from "../../utils/helperFunctions/getLocation";

import { fetchSpecificListingApi } from "./fetchSpecialListing";
import { fetchListingSlice } from "./fetchListingsforUser";
import { fetchStateListingApi } from "./fetchStateListingThunk";
// import { fetchListingSlice } from "./fetchListing";

interface IResponse {
  message: string;
}

interface IParams {
  id: string;
  uid: string;
  item: CreateListingFormData;
  images: File[];
}

interface IRejected {
  message: string;
}

export const updateListingThunk = createAsyncThunk<
  IResponse,
  IParams,
  { rejectValue: IRejected }
>("listing/updatingListing", async (params, thunkAPI) => {
  try {
    const ref = doc(db, "allListings", params.id);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      return thunkAPI.rejectWithValue({ message: "Document not found" });
    }

    const uploadedUrls: string[] = await Promise.all(
      params.images.slice(0, 6).map((file: File) => uploadToCloudinary(file))
    );
    console.log("uploadedUrls", uploadedUrls);

    const location = await getLatLng(params.item.address);

    const item = {
      ...params.item,
      id: params.id,
      images: uploadedUrls,
      location
    };

    await updateDoc(ref, item);

    // Invalidate cache for this user's listings

    thunkAPI.dispatch(
      fetchSpecificListingApi.util.invalidateTags([{ type: "allListings" }])
    );
    thunkAPI.dispatch(
      fetchListingSlice.util.invalidateTags([{ type: "allListings" }])
    );
    thunkAPI.dispatch(
      fetchStateListingApi.util.invalidateTags([{ type: "LISTINGS" }])
    );

    return { message: "Updating listing " };
  } catch (error) {
    return thunkAPI.rejectWithValue({
      message: "Something went wrong for updating the listing"
    });
  }
});
